import { FC } from 'react';

const DividerVertical: FC = () => (
  <div className="
    h-full min-h-[1em] w-px self-stretch bg-gradient-to-tr from-transparent via-neutral-500 to-transparent opacity-25 dark:via-neutral-400
  "/>
);

export default DividerVertical;
